<div class="app-canvas">
	<main id="app-main" class="app-main" role="main">
		<router-outlet />
	</main>

	<div
		class="splash-backdrop"
		*ngIf="(authStore.isAuthenticated$ | async) && (authStore.profileLoading$ | async)"
	>
		<div class="splash-content">
			<div class="splash-spinner"></div>
			<p>Preparing your workspace...</p>
		</div>
	</div>
</div>
